import React, { memo, useEffect, useState } from "react";
import './dashboard.css';
import { SpinnerRoundFilled } from "spinners-react";
import { Row, notification, Col, Select, } from "antd";
import Axios from "./../../config/axiosConfig/axios";
import { Api } from "./../../config/apiList/api";


function Dashboard() {
    const { Option } = Select;
    const [step, setStep] = useState(0);
    const [data,setData]=useState(null);

    const GreenNotification = (text) => {
        notification.open({
            message: "موفقیت",
            description: text,
            style: {
                background: "#43a047",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }

    const RedNotification = (text) => {
        notification.open({
            message: "اخطار",
            description: text,
            style: {
                background: "#F3585c",
                color: "white",
                fontFamily: "IRANSansMobileFaNum",
                borderRadius: "5px",
            }
        })
    }


    useEffect(() => {

        Axios.get(`${Api}dashboard`)
            .then((data) => {
                if (data.statusCode === 200 || data.statusCode === 201) {
                    setData(data.data.data);
                    setStep(1);
                }

            })
            .catch((error) => {
            });
    }, []);


    switch (step) {
        case 0: return (
            <Row style={{ width: '100', justifyContent: 'center' }}>
                <SpinnerRoundFilled style={{ marginTop: '30px' }} size={50} thickness={100} speed={100} color="rgba(57, 119, 172, 1)" />
            </Row>
        )
        case 1: return (
            <>
                {/*<Row style={{ alignItems: 'center', paddingTop: '10px', display: "flex", justifyContent: "center" }}>*/}
                    {/*<Col xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">*/}

                    {/*    <p className="dashboradTitle">کل سفارشات معمولی</p>*/}
                    {/*    <p className="dashboradSubTitle">463643</p>*/}
                    {/*</Col>*/}
                    {/*<Col xxl={6} xl={6} lg={6} md={6} style={{ textAlign: 'center' }} className="dashboardColume">*/}

                    {/*    <p className="dashboradTitle" >تعداد کاربران دارای اعتبار</p>*/}
                    {/*    <p className="dashboradSubTitle">{data.validUsers}</p>*/}
                    {/*</Col>*/}

                    {/*<Col xxl={6} xl={6} lg={6} md={6} style={{ textAlign: 'center' }} className="dashboardColume">*/}

                    {/*    <p className="dashboradTitle" >تعداد کل کاربران</p>*/}
                    {/*    <p className="dashboradSubTitle">{data.userCount}</p>*/}
                    {/*</Col>*/}
                    {/*<Col xxl={6} xl={6} lg={6} md={6} style={{ textAlign: 'center' }} className="dashboardColume">*/}

                    {/*    <p className="dashboradTitle">تعداد کاربران فاقد اعتبار</p>*/}
                    {/*    <p className="dashboradSubTitle">{data.notValidUsers}</p>*/}
                    {/*</Col>*/}
                {/*</Row>*/}
                <Row  style={{ paddingTop: '10px' }}>

                    <Col  xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">

                        <p className="dashboradTitle" >تعداد کل کاربران</p>
                        <p className="dashboradSubTitle">{data.userCount}</p>
                    </Col>
                    {/*<Col xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">*/}

                    {/*    <p className="dashboradTitle">تعداد کل کاربران</p>*/}
                    {/*    <p className="dashboradSubTitle">1500</p>*/}
                    {/*</Col>*/}
                    <Col xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">

                        <p className="dashboradTitle" >تعداد املاک ثبت شده</p>
                        <p className="dashboradSubTitle">{data.amlakCount}</p>
                    </Col>
                    <Col  xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">

                        <p className="dashboradTitle" >تعداد کل ملک های ثبت شده</p>
                        <p className="dashboradSubTitle">{data.validMelks}</p>
                    </Col>
                    <Col  xxl={5} xl={5} lg={5} md={5} style={{ textAlign: 'center' }} className="dashboardColume">
                        <p className="dashboradTitle">تعداد ملک های تایید نشده</p>
                        <p className="dashboradSubTitle">{data.notValidMelks}</p>
                    </Col>
                </Row>
            </>
        )
        case 2: return (
            <>
            </>
        )

    }

}
export default memo(Dashboard);